/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type AirlineStatus = typeof AirlineStatus[keyof typeof AirlineStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AirlineStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
} as const;
